module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/index/img_article01-8fc59b59542db2fbff1594822cd564f2.png";